import {Directive, Input} from '@angular/core';
import { PermissionsHelperService } from 'src/app/services/permissions-helper/permissions-helper.service';
import { PermissionTypes } from '../../model/enum/permission-types.enum';

@Directive({
    selector: '[permissionsAll], [permissionsAny]',
    host: {
        '[class.access-control-hide]': 'denyAccess()'
    }
})
export class PermissionsDirective {
    @Input() permissionsAll: PermissionTypes[] = [];
    @Input() permissionsAny: PermissionTypes[] = [];

    constructor(private permissionsHelperService: PermissionsHelperService) {}

    denyAccess() {
        return !this.permissionsHelperService.doIHaveAllPermissions(this.permissionsAll)
            || !this.permissionsHelperService.doIHaveAnyPermissions(this.permissionsAny);
    }
}